import store from '@/store';
import { Image } from 'antd';
import { useSelector } from 'react-redux';

// 全局开启图片预览
export default () => {
  const system = useSelector((state: any) => state.system);
  return (
    <Image.PreviewGroup
      items={system.images}
      preview={{
        visible: system.visible,
        onVisibleChange: (visible: boolean) => {
          if (!visible) {
            store.dispatch({ type: 'system/onImagePreview', payload: { visible } });
          }
        },
      }}
    />
  );
};
